/**
 * Circular emoji badges — contrasting pill in light/dark mode.
 * @see components.css `.emoji-badge`
 */

/**
 * @param {string} emoji
 * @param {'sm'|'md'|'lg'|'xl'} [size='md']
 * @returns {string}
 */
export function renderEmojiBadge(emoji, size = 'md') {
  if (!emoji) return '';
  return `<span class="emoji-badge emoji-badge-${size}" aria-hidden="true">${emoji}</span>`;
}

/**
 * Page/section heading with a leading emoji badge.
 * @param {string} emoji
 * @param {string} titleHtml - caller escapes user content; plain text is fine
 * @param {string} [tag='h2']
 * @returns {string}
 */
export function renderPageTitle(emoji, titleHtml, tag = 'h2') {
  return `<${tag} class="page-title">${renderEmojiBadge(emoji, 'lg')}${titleHtml}</${tag}>`;
}

/**
 * Nav menu label with emoji badge.
 * @param {string} emoji
 * @param {string} label
 * @returns {string}
 */
export function renderNavLabel(emoji, label) {
  return `${renderEmojiBadge(emoji, 'sm')}${label}`;
}
